export const enum DefaultColorName {
    ALARM = 'Alarm',
    CAUTION = 'Caution',
    WARNING = 'Warning',
    ALARM_REPOSE = 'Alarm repose',
    SENSOR_FAILURE = 'Sensor failure',
    FU_UNRESPONSIVE = 'FU unresponsive',
    DIGITAL_ON = 'Digital on',
    DIGITAL_OFF = 'Digital off',
    MOTOR_RUNNING = 'Motor running',
    MOTOR_STOP = 'Motor stop',
    MOTOR_STANDBY = 'Motor standby',
    VALVE_OPEN = 'Valve open',
    VALVE_CLOSE = 'Valve close',
}

export const enum SystemColorType {
    Alarm = 'Alarm',
    Sensor = 'Sensor',
    Digital = 'Digital',
    Valve = 'Valve',
    Custom = 'Custom',
}

export class SystemColor {
    id?: string;
    name: string;
    color: string;
    type: SystemColorType | string;
    vesselId?: string;
    isEditable?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
}

export type SystemColorMap = {
    [key: string]: {
        systemColorId?: string;
        color: string;
    };
};

export const DefaultColorsOrder = [
    DefaultColorName.ALARM,
    DefaultColorName.WARNING,
    DefaultColorName.CAUTION,
    DefaultColorName.ALARM_REPOSE,
    DefaultColorName.SENSOR_FAILURE,
    DefaultColorName.FU_UNRESPONSIVE,
    DefaultColorName.DIGITAL_ON,
    DefaultColorName.DIGITAL_OFF,
    DefaultColorName.MOTOR_RUNNING,
    DefaultColorName.MOTOR_STOP,
    DefaultColorName.MOTOR_STANDBY,
    DefaultColorName.VALVE_OPEN,
    DefaultColorName.VALVE_CLOSE,
];
